export default __webpack_public_path__ + "static/project-slide-6-768-700-34e9a63229ab165bfd43b34f53293bfe.webp";